import { NavLink as RouterLink, useLocation } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Button, AppBar, Toolbar, Container } from '@material-ui/core';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
// components
import Logo from '../../components/Logo';
import Label from '../../components/Label';
import { MHidden } from '../../components/@material-extend';
//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import navConfig from './MenuConfig';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 88;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(['height', 'background-color', 'max-width', 'border-radius', 'padding', 'margin', 'box-shadow'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  }),
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP
  }
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8
}));

// ----------------------------------------------------------------------

export default function MainNavbar() {
  const isOffset = useOffSetTop(100);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <AppBar color="transparent" sx={{ boxShadow: 0, pt: isOffset ? 0 : { xs: 2, md: 3 }, transition: (theme) => theme.transitions.create(['padding-top'], { duration: theme.transitions.duration.standard }) }}>
      <ToolbarStyle
        disableGutters
        sx={{
          margin: '0 auto',
          width: '100%',
          maxWidth: isOffset ? '100%' : 1200,
          borderRadius: isOffset ? 0 : 4,
          bgcolor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 10px 40px -10px rgba(0,0,0,0.15)',
          border: isOffset ? 'none' : '1px solid rgba(255,255,255,0.5)',
          px: { xs: 2, md: 4 },
          ...(isOffset && {
            pt: 0,
            bgcolor: 'background.default',
            height: { md: APP_BAR_DESKTOP - 16 },
            px: 0
          })
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {/* Left: Logo */}
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>

          {/* Center: Navigation Links */}
          <Box sx={{ flex: 2, display: 'flex', justifyContent: 'center' }}>
            <MHidden width="mdDown">
              <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={navConfig} />
            </MHidden>
          </Box>

          {/* Right: Actions / Mobile Menu */}
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button variant="contained" component={RouterLink} to="/auth/login">
              Login
            </Button>
            <MHidden width="mdUp">
              <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={navConfig} />
            </MHidden>
          </Box>
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
